import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, vModelText as _vModelText, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = {
  key: 0,
  class: "card-header"
}
const _hoisted_3 = { class: "d-flex flex-row bd-highlight pt-2" }
const _hoisted_4 = ["data-bs-target", "aria-controls"]
const _hoisted_5 = ["data-bs-target", "aria-controls"]
const _hoisted_6 = {
  key: 3,
  class: "dropdown"
}
const _hoisted_7 = { class: "dropdown-menu" }
const _hoisted_8 = {
  key: 0,
  class: "alert alert-primary bg-transparent text-primary mt-3 mx-3 font-10",
  role: "alert"
}
const _hoisted_9 = {
  key: 1,
  class: "card-header"
}
const _hoisted_10 = { class: "d-flex flex-row bd-highlight" }
const _hoisted_11 = ["data-bs-target", "aria-controls"]
const _hoisted_12 = { class: "card-body pt-1" }
const _hoisted_13 = {
  key: 0,
  class: "progress",
  style: {"height":"8px","border-radius":"0px"}
}
const _hoisted_14 = {
  key: 1,
  class: "col-12"
}
const _hoisted_15 = {
  class: "h5",
  role: "group",
  "aria-label": "Filtros aplicados à listagem"
}
const _hoisted_16 = { class: "badge bg-light text-dark ms-1 me-1" }
const _hoisted_17 = { style: {"font-weight":"normal"} }
const _hoisted_18 = {
  key: 2,
  class: "table tablesorter table-mobile"
}
const _hoisted_19 = {
  key: 0,
  class: "mobile-table-row"
}
const _hoisted_20 = {
  key: 1,
  class: "mobile-table-row"
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "mobile-row-cell" }
const _hoisted_23 = { class: "form-check mb-2" }
const _hoisted_24 = ["value", "aria-label"]
const _hoisted_25 = {
  key: 1,
  class: "mobile-row mb-1"
}
const _hoisted_26 = { class: "mobile-row-header" }
const _hoisted_27 = { class: "mobile-row-cell" }
const _hoisted_28 = {
  key: 2,
  class: "mobile-row mb-1"
}
const _hoisted_29 = { class: "mobile-row-cell" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "mobile-row-header" }
const _hoisted_32 = { class: "mobile-row-cell" }
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { key: 2 }
const _hoisted_36 = ["disabled", "onChange", "onUpdate:modelValue", "aria-label"]
const _hoisted_37 = { key: 3 }
const _hoisted_38 = ["disabled", "onChange", "onUpdate:modelValue", "aria-label"]
const _hoisted_39 = { key: 4 }
const _hoisted_40 = ["disabled", "onChange", "rows", "onUpdate:modelValue", "aria-label"]
const _hoisted_41 = { key: 5 }
const _hoisted_42 = ["disabled", "onChange", "onUpdate:modelValue", "aria-label"]
const _hoisted_43 = {
  key: 6,
  class: "form-check"
}
const _hoisted_44 = { class: "form-check-label" }
const _hoisted_45 = ["onUpdate:modelValue", "aria-label", "disabled"]
const _hoisted_46 = { key: 7 }
const _hoisted_47 = { key: 8 }
const _hoisted_48 = ["disabled", "onChange", "onUpdate:modelValue", "aria-label"]
const _hoisted_49 = { key: 9 }
const _hoisted_50 = { key: 10 }
const _hoisted_51 = ["disabled", "onChange", "onUpdate:modelValue", "aria-label"]
const _hoisted_52 = ["id"]
const _hoisted_53 = {
  key: 0,
  class: "text-primary"
}
const _hoisted_54 = {
  key: 0,
  scope: "col"
}
const _hoisted_55 = {
  key: 1,
  scope: "col"
}
const _hoisted_56 = {
  key: 3,
  scope: "col"
}
const _hoisted_57 = ["hidden", "data-datafield", "aria-sort"]
const _hoisted_58 = ["onClick", "title", "aria-label"]
const _hoisted_59 = { key: 0 }
const _hoisted_60 = ["onClick", "title", "aria-label"]
const _hoisted_61 = ["aria-label", "aria-valuenow", "aria-valuemin", "aria-valuemax", "aria-valuetext", "onMousedown", "onKeydown"]
const _hoisted_62 = { key: 0 }
const _hoisted_63 = ["colspan"]
const _hoisted_64 = { key: 1 }
const _hoisted_65 = ["colspan"]
const _hoisted_66 = { key: 0 }
const _hoisted_67 = ["value", "aria-label"]
const _hoisted_68 = { key: 1 }
const _hoisted_69 = ["onClick"]
const _hoisted_70 = {
  key: 3,
  class: "text-center",
  style: {"width":"200px"}
}
const _hoisted_71 = ["onClick"]
const _hoisted_72 = ["id"]
const _hoisted_73 = {
  key: 0,
  class: "row"
}
const _hoisted_74 = { class: "table mb-1 table-centered table-nowrap" }
const _hoisted_75 = ["innerHTML"]
const _hoisted_76 = { key: 1 }
const _hoisted_77 = {
  key: 2,
  class: "form-check"
}
const _hoisted_78 = { class: "form-check-label" }
const _hoisted_79 = ["onUpdate:modelValue"]
const _hoisted_80 = { key: 3 }
const _hoisted_81 = { key: 4 }
const _hoisted_82 = { key: 2 }
const _hoisted_83 = ["innerHTML"]
const _hoisted_84 = { key: 1 }
const _hoisted_85 = { key: 2 }
const _hoisted_86 = ["disabled", "onChange", "onUpdate:modelValue", "aria-label"]
const _hoisted_87 = { key: 3 }
const _hoisted_88 = ["disabled", "onChange", "onUpdate:modelValue", "aria-label"]
const _hoisted_89 = { key: 4 }
const _hoisted_90 = ["id", "disabled", "onChange", "onInput", "rows", "onUpdate:modelValue", "aria-label"]
const _hoisted_91 = { key: 5 }
const _hoisted_92 = ["disabled", "onChange", "onUpdate:modelValue", "aria-label"]
const _hoisted_93 = {
  key: 6,
  class: "form-check"
}
const _hoisted_94 = { class: "form-check-label" }
const _hoisted_95 = ["onChange", "onUpdate:modelValue", "aria-label", "disabled"]
const _hoisted_96 = { key: 7 }
const _hoisted_97 = { key: 8 }
const _hoisted_98 = ["disabled", "onChange", "onUpdate:modelValue", "aria-label"]
const _hoisted_99 = { key: 9 }
const _hoisted_100 = { key: 10 }
const _hoisted_101 = ["disabled", "onChange", "onUpdate:modelValue", "aria-label"]
const _hoisted_102 = {
  key: 3,
  class: "grid-footer"
}
const _hoisted_103 = { "aria-label": "Paginação da listagem" }
const _hoisted_104 = { class: "pagination pagination-rounded" }
const _hoisted_105 = { class: "paginate_button page-item" }
const _hoisted_106 = ["disabled"]
const _hoisted_107 = { class: "paginate_button page-item previous" }
const _hoisted_108 = ["disabled"]
const _hoisted_109 = ["onClick", "aria-current", "aria-label"]
const _hoisted_110 = { class: "paginate_button page-item next" }
const _hoisted_111 = ["disabled"]
const _hoisted_112 = { class: "paginate_button page-item" }
const _hoisted_113 = ["disabled"]
const _hoisted_114 = {
  class: "regiao-anuncio",
  role: "status",
  "aria-live": "polite",
  "aria-atomic": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConsulteGridViews = _resolveComponent("ConsulteGridViews")!
  const _component_ConsulteGridFilters = _resolveComponent("ConsulteGridFilters")!
  const _component_ConsulteGridColumnSelection = _resolveComponent("ConsulteGridColumnSelection")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.hideHeader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "header"),
            (_ctx.showViewsManager)
              ? (_openBlock(), _createBlock(_component_ConsulteGridViews, {
                  key: 0,
                  columns: _ctx.columnsData,
                  "onUpdate:columns": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.columnsData) = $event)),
                  onOnSelectView: _ctx.onSelectView
                }, null, 8, ["columns", "onOnSelectView"]))
              : _createCommentVNode("", true),
            (
          _ctx.showFilterButton &&
          _ctx.$refs.componentFilter &&
          _ctx.$refs.componentFilter.filterableColumns &&
          _ctx.$refs.componentFilter.filterableColumns?.length > 0
        )
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  title: "Filtrar dados do grid",
                  class: "btn btn-soft-secondary btn-sm ms-1",
                  type: "button",
                  "data-bs-toggle": "offcanvas",
                  "data-bs-target": `[id='${_ctx.idFilters.toString()}']`,
                  "aria-controls": _ctx.idFilters.toString(),
                  "aria-label": "Filtrar dados do grid"
                }, [...(_cache[19] || (_cache[19] = [
                  _createElementVNode("i", {
                    class: "uil-search-alt",
                    "aria-hidden": "true"
                  }, null, -1)
                ]))], 8, _hoisted_4))
              : _createCommentVNode("", true),
            (_ctx.showColumnSelectionButton && _ctx.$refs.componentColumnsSelection)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  title: "Selecionar Colunas Grid",
                  class: "btn btn-soft-secondary btn-sm ms-1",
                  type: "button",
                  "data-bs-toggle": "offcanvas",
                  "data-bs-target": `[id='${_ctx.idColumns.toString()}']`,
                  "aria-controls": _ctx.idColumns.toString(),
                  "aria-label": "Selecionar Colunas Grid"
                }, [...(_cache[20] || (_cache[20] = [
                  _createElementVNode("i", {
                    class: "uil-grid",
                    "aria-hidden": "true"
                  }, null, -1)
                ]))], 8, _hoisted_5))
              : _createCommentVNode("", true),
            false
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _cache[21] || (_cache[21] = _createElementVNode("button", {
                    class: "btn btn-primary dropdown-toggle ms-1 me-2",
                    type: "button",
                    "data-bs-toggle": "dropdown"
                  }, [
                    _createElementVNode("i", {
                      class: "uil-print",
                      "aria-hidden": "true"
                    }),
                    _createTextVNode(" Exportar ")
                  ], -1)),
                  _createElementVNode("ul", _hoisted_7, [
                    _createElementVNode("li", null, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "dropdown-item",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.imprimirExportar('PDF')))
                      }, "PDF")
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "dropdown-item",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.imprimirExportar('HTML')))
                      }, "HTML")
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "dropdown-item",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.imprimirExportar('XLSX')))
                      }, "XLSX")
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "dropdown-item",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.imprimirExportar('DOC')))
                      }, "DOC")
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "dropdown-item",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.imprimirExportar('PÁGINA')))
                      }, "TELA")
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.sortFields?.length > 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 4,
                  title: "Limpar Ordenação",
                  class: "btn btn-soft-secondary btn-sm ms-1 me-2",
                  type: "button",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.clearGridSort())),
                  "aria-label": "Limpar Ordenação"
                }, [...(_cache[22] || (_cache[22] = [
                  _createElementVNode("i", {
                    class: "ri-sort-asc",
                    "aria-hidden": "true"
                  }, null, -1)
                ]))]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.sortFields?.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.sortFields), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.onlySearchHeader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            (
          _ctx.showFilterButton &&
          _ctx.$refs.componentFilter &&
          _ctx.$refs.componentFilter.filterableColumns &&
          _ctx.$refs.componentFilter.filterableColumns?.length > 0
        )
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  title: "Filtrar dados do grid",
                  class: "btn btn-soft-secondary btn-sm ms-auto",
                  type: "button",
                  "data-bs-toggle": "offcanvas",
                  "data-bs-target": `[id='${_ctx.idFilters.toString()}']`,
                  "aria-controls": _ctx.idFilters.toString(),
                  "aria-label": "Filtrar dados do grid"
                }, [...(_cache[23] || (_cache[23] = [
                  _createElementVNode("i", {
                    class: "uil-search-alt",
                    "aria-hidden": "true"
                  }, null, -1),
                  _createTextVNode(" Pesquisar ", -1)
                ]))], 8, _hoisted_11))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_ConsulteGridFilters, {
        "id-filters": _ctx.idFilters.toString(),
        columns: _ctx.columnsData,
        "data-source": _ctx.dataSource,
        ref: "componentFilter"
      }, null, 8, ["id-filters", "columns", "data-source"]),
      _createVNode(_component_ConsulteGridColumnSelection, {
        "id-columns": _ctx.idColumns.toString(),
        columns: _ctx.columnsData,
        "onUpdate:columns": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.columnsData) = $event)),
        "data-source": _ctx.dataSource,
        ref: "componentColumnsSelection"
      }, null, 8, ["id-columns", "columns", "data-source"]),
      (_ctx.barraRolagemSuperior)
        ? _withDirectives((_openBlock(), _createElementBlock("div", {
            key: 0,
            ref: "rolagemSuperior",
            class: "consulte-grid-rolagem-superior",
            "aria-hidden": "true",
            onScroll: _cache[8] || (_cache[8] = ($event: any) => (_ctx.sincronizarRolagem('superior')))
          }, [
            _createElementVNode("div", {
              class: "consulte-grid-rolagem-superior-trilho",
              style: _normalizeStyle({ width: `${_ctx.larguraDoConteudo}px` })
            }, null, 4)
          ], 544)), [
            [_vShow, _ctx.precisaRolagemHorizontal]
          ])
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "table-responsive ps",
        ref: "areaRolagemExterna",
        onScroll: _cache[18] || (_cache[18] = ($event: any) => (_ctx.sincronizarRolagem('area')))
      }, [
        (_ctx.dataSource?.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [...(_cache[24] || (_cache[24] = [
              _createElementVNode("div", {
                class: "progress-bar progress-bar-striped progress-bar-animated",
                role: "progressbar",
                "aria-label": "Carregando registros",
                style: {"width":"100%"}
              }, null, -1)
            ]))]))
          : _createCommentVNode("", true),
        (_ctx.showAppliedFilters)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.$refs.componentFilter?.flitersToDisplay ?? {}), (key) => {
                  return (_openBlock(), _createElementBlock("span", {
                    class: "badge bg-success me-1",
                    key: key
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$refs.componentFilter.getDescriptionFilter(key)) + " ", 1),
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$refs.componentFilter.getDescriptionFilterExpression(key)), 1),
                    _createElementVNode("strong", _hoisted_17, _toDisplayString(_ctx.$refs.componentFilter.flitersToDisplay[key]), 1)
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.windowWidth <= 600)
          ? (_openBlock(), _createElementBlock("table", _hoisted_18, [
              _createElementVNode("tbody", null, [
                (_ctx.dataSource?.loading)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [...(_cache[25] || (_cache[25] = [
                      _createElementVNode("td", { class: "mobile-row" }, [
                        _createElementVNode("div", {
                          class: "col-1 mini-loader",
                          role: "status"
                        }, [
                          _createElementVNode("div", {
                            class: "spinner-border text-primary",
                            "aria-hidden": "true"
                          }),
                          _createElementVNode("span", { class: "apenas-leitor-tela" }, "Carregando registros...")
                        ])
                      ], -1)
                    ]))]))
                  : _createCommentVNode("", true),
                (!_ctx.dataSource?.loading && (_ctx.dataSource?.rows?.length ?? 0) == 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [...(_cache[26] || (_cache[26] = [
                      _createElementVNode("td", { class: "mobile-row" }, [
                        _createElementVNode("i", null, "Nenhum resultado")
                      ], -1)
                    ]))]))
                  : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "body", {}, () => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSource?.rows, (row) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: (row as any),
                      class: _normalizeClass('mobile-table-row ' + row._rowClass)
                    }, [
                      (_ctx.selectable)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_21, [
                            _cache[27] || (_cache[27] = _createElementVNode("div", { class: "mobile-row-header" }, null, -1)),
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("div", _hoisted_23, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onChangeSelection && _ctx.onChangeSelection(...args))),
                                  value: row,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.rowsSelected) = $event)),
                                  class: "form-check-input",
                                  "aria-label": _ctx.rotuloSelecaoLinha(row, 0)
                                }, null, 40, _hoisted_24), [
                                  [_vModelCheckbox, _ctx.rowsSelected]
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.actions)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.tituloActions), 1),
                            _createElementVNode("div", _hoisted_27, [
                              _renderSlot(_ctx.$slots, "actions", { row: row })
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.buttonClickSave)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_28, [
                            _cache[29] || (_cache[29] = _createElementVNode("div", { class: "mobile-row-header" }, null, -1)),
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("button", {
                                title: "Salvar dados da linha",
                                onClick: ($event: any) => (_ctx.onChangeDataRow(row, $event)),
                                class: "btn btn-sm btn-success",
                                style: {"margin-right":"5px"},
                                "aria-label": "Salvar dados da linha"
                              }, [...(_cache[28] || (_cache[28] = [
                                _createElementVNode("i", {
                                  class: "mdi mdi-floppy",
                                  "aria-hidden": "true"
                                }, null, -1)
                              ]))], 8, _hoisted_30)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnsData, (column, index) => {
                        return (_openBlock(), _createElementBlock("td", {
                          key: column.datafield,
                          class: "mobile-row"
                        }, [
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.getColumnByDataField(column.datafield)?.text), 1)
                          ]),
                          _createElementVNode("div", _hoisted_32, [
                            _renderSlot(_ctx.$slots, column.datafield, { row: row }, () => [
                              (column.cellsrenderer)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    innerHTML: column.cellsrenderer(
                        index,
                        column.datafield,
                        (row as any)[column.datafield]
                      )
                        
                                  }, null, 8, _hoisted_33))
                                : _createCommentVNode("", true),
                              (!column.cellsrenderer && !column.columntype && !(typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == true))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString((row as any)[column.datafield]), 1))
                                : _createCommentVNode("", true),
                              (!column.cellsrenderer && !column.columntype && (typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == true) && (typeof (row as any)[column.datafield]) == 'number')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                    _withDirectives(_createElementVNode("input", {
                                      disabled: (typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == false),
                                      onChange: ($event: any) => (_ctx.buttonClickSave ? () => { } : _ctx.onChangeDataRow(row as any, $event)),
                                      type: "number",
                                      "onUpdate:modelValue": ($event: any) => (((row as any)[column.datafield]) = $event),
                                      "aria-label": column.text,
                                      class: "form-control"
                                    }, null, 40, _hoisted_36), [
                                      [_vModelText, (row as any)[column.datafield]]
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (!column.cellsrenderer && column.editinputdefinition == undefined && !column.columntype && (typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == true) && (typeof (row as any)[column.datafield]) != 'number')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                    _withDirectives(_createElementVNode("input", {
                                      disabled: (typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == false),
                                      onChange: ($event: any) => (_ctx.buttonClickSave ? () => { } : _ctx.onChangeDataRow(row as any, $event)),
                                      type: "text",
                                      "onUpdate:modelValue": ($event: any) => (((row as any)[column.datafield]) = $event),
                                      "aria-label": column.text,
                                      class: "form-control"
                                    }, null, 40, _hoisted_38), [
                                      [_vModelText, (row as any)[column.datafield]]
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (!column.cellsrenderer &&
                          ((typeof column.editinputdefinition === 'object' && (column.editinputdefinition as any).type == 'textarea') || typeof column.editinputdefinition === 'string' && column.editinputdefinition == 'textarea')
                          && !column.columntype && (typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == true) && (typeof (row as any)[column.datafield]) != 'number')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                    _withDirectives(_createElementVNode("textarea", {
                                      disabled: (typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == false),
                                      onChange: ($event: any) => (_ctx.buttonClickSave ? () => { } : _ctx.onChangeDataRow(row as any, $event)),
                                      rows: (typeof column.editinputdefinition === 'object') ? ((column.editinputdefinition as any)?.rows ?? 1) : 1,
                                      "onUpdate:modelValue": ($event: any) => (((row as any)[column.datafield]) = $event),
                                      "aria-label": column.text,
                                      class: "form-control"
                                    }, null, 40, _hoisted_40), [
                                      [_vModelText, (row as any)[column.datafield]]
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (column.columntype && column.columntype == 'number' && (typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == true))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                    _withDirectives(_createElementVNode("input", {
                                      disabled: (typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == false),
                                      onChange: ($event: any) => (_ctx.buttonClickSave ? () => { } : _ctx.onChangeDataRow(row as any, $event)),
                                      type: "number",
                                      "onUpdate:modelValue": ($event: any) => (((row as any)[column.datafield]) = $event),
                                      "aria-label": column.text,
                                      class: "form-control"
                                    }, null, 40, _hoisted_42), [
                                      [_vModelText, (row as any)[column.datafield]]
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (column.columntype && column.columntype == 'checkbox')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                    _createElementVNode("label", _hoisted_44, [
                                      _withDirectives(_createElementVNode("input", {
                                        class: "form-check-input",
                                        type: "checkbox",
                                        "onUpdate:modelValue": ($event: any) => (((row as any)[column.datafield]) = $event),
                                        "aria-label": column.text,
                                        disabled: (typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == false)
                                      }, null, 8, _hoisted_45), [
                                        [_vModelCheckbox, (row as any)[column.datafield]]
                                      ]),
                                      _cache[30] || (_cache[30] = _createElementVNode("span", { class: "form-check-sign" }, null, -1))
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (column.columntype && column.columntype == 'date' && !(typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == false)
                      )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(new Date((row as any)[column.datafield]).toLocaleDateString()), 1))
                                : _createCommentVNode("", true),
                              (column.columntype && column.columntype == 'date' && column.editable)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                    _withDirectives(_createElementVNode("input", {
                                      disabled: (typeof column.editable === 'function' ? !column.editable((row as any)) : false),
                                      onChange: ($event: any) => (_ctx.buttonClickSave ? () => { } : _ctx.onChangeDataRow(row as any, $event)),
                                      class: "form-control",
                                      type: "date",
                                      "onUpdate:modelValue": ($event: any) => (((row as any)[column.datafield]) = $event),
                                      "aria-label": column.text
                                    }, null, 40, _hoisted_48), [
                                      [_vModelText, (row as any)[column.datafield]]
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (column.columntype && column.columntype == 'datetime' && !(typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == true)
                      )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString((row as any)[column.datafield]
                            ? _ctx.moment(new Date((row as any)[column.datafield])).format(
                              'DD/MM/yyyy HH:mm'
                            )
                            : ''), 1))
                                : _createCommentVNode("", true),
                              (column.columntype && column.columntype == 'datetime' && (typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == true)
                      )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                    _withDirectives(_createElementVNode("input", {
                                      disabled: (typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == false),
                                      onChange: ($event: any) => (_ctx.buttonClickSave ? () => { } : _ctx.onChangeDataRow(row as any, $event)),
                                      class: "form-control",
                                      type: "datetime-local",
                                      "onUpdate:modelValue": ($event: any) => (((row as any)[column.datafield]) = $event),
                                      "aria-label": column.text
                                    }, null, 40, _hoisted_51), [
                                      [_vModelText, (row as any)[column.datafield]]
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      }), 128))
                    ], 2))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          id: _ctx.useFreezedColumn() ? 'table-scroll' : undefined,
          class: _normalizeClass({ 'table-scroll': _ctx.useFreezedColumn() })
        }, [
          _createElementVNode("div", {
            class: _normalizeClass({ 'table-wrap': _ctx.useFreezedColumn() }),
            ref: "areaRolagemInterna",
            onScroll: _cache[13] || (_cache[13] = ($event: any) => (_ctx.sincronizarRolagem('area')))
          }, [
            (_ctx.windowWidth > 600)
              ? (_openBlock(), _createElementBlock("table", {
                  key: 0,
                  class: _normalizeClass({
              'main-table mb-1 table-centered mb-0': _ctx.useFreezedColumn(),
              'table mb-1 table-centered mb-0': !_ctx.useFreezedColumn(),
            }),
                  id: "tabelaConsulteGrid"
                }, [
                  (!_ctx.hideHeaderGrid)
                    ? (_openBlock(), _createElementBlock("thead", _hoisted_53, [
                        _createElementVNode("tr", null, [
                          (_ctx.selectable)
                            ? (_openBlock(), _createElementBlock("th", _hoisted_54, [...(_cache[31] || (_cache[31] = [
                                _createElementVNode("span", { class: "apenas-leitor-tela" }, "Selecionar", -1)
                              ]))]))
                            : _createCommentVNode("", true),
                          (_ctx.rowDetails)
                            ? (_openBlock(), _createElementBlock("th", _hoisted_55, [...(_cache[32] || (_cache[32] = [
                                _createElementVNode("span", { class: "apenas-leitor-tela" }, "Detalhes", -1)
                              ]))]))
                            : _createCommentVNode("", true),
                          (_ctx.actions)
                            ? (_openBlock(), _createElementBlock("th", {
                                key: 2,
                                class: _normalizeClass({ 'fixed-side': _ctx.useFreezedColumn() }),
                                scope: "col"
                              }, _toDisplayString(_ctx.tituloActions), 3))
                            : _createCommentVNode("", true),
                          (_ctx.buttonClickSave)
                            ? (_openBlock(), _createElementBlock("th", _hoisted_56, [...(_cache[33] || (_cache[33] = [
                                _createElementVNode("span", { class: "apenas-leitor-tela" }, "Salvar", -1)
                              ]))]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnsData, (column) => {
                            return (_openBlock(), _createElementBlock("th", {
                              key: column.datafield,
                              hidden: column.hidden,
                              class: _normalizeClass([{ 'fixed-side': column.freezedcolumn }, "consulte-grid-th-resizable"]),
                              style: _normalizeStyle(_ctx.getColumnStyle(column)),
                              "data-datafield": column.datafield,
                              scope: "col",
                              "aria-sort": _ctx.direcaoOrdenacaoAria(column)
                            }, [
                              _renderSlot(_ctx.$slots, `cabecalho-${column.datafield}`, { column: column }, () => [
                                _createTextVNode(_toDisplayString(column.text), 1)
                              ]),
                              _createElementVNode("span", null, [
                                (_ctx.$props.useColumnSort && _ctx.colunaOrdenavel(column))
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      type: "button",
                                      class: "btn btn-link p-0 border-0 align-baseline",
                                      style: {"background":"transparent"},
                                      onClick: ($event: any) => (_ctx.sortResult(column.datafield)),
                                      title: _ctx.rotuloBotaoOrdenar(column),
                                      "aria-label": _ctx.rotuloBotaoOrdenar(column)
                                    }, [...(_cache[34] || (_cache[34] = [
                                      _createElementVNode("i", {
                                        class: "mdi mdi-order-alphabetical-ascending text-success",
                                        "aria-hidden": "true"
                                      }, null, -1)
                                    ]))], 8, _hoisted_58))
                                  : _createCommentVNode("", true)
                              ]),
                              (_ctx.$props.useColumnSort && _ctx.colunaOrdenada(column.datafield))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_59, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "btn btn-link p-0 border-0 align-baseline",
                                      style: {"background":"transparent"},
                                      onClick: ($event: any) => (_ctx.removerOrdenacao(column.datafield)),
                                      title: `Remover a ordenação por ${column.text}`,
                                      "aria-label": `Remover a ordenação por ${column.text}`
                                    }, [...(_cache[35] || (_cache[35] = [
                                      _createElementVNode("i", {
                                        class: "mdi mdi-close text-danger consulte-grid-remover-ordenacao",
                                        "aria-hidden": "true"
                                      }, null, -1)
                                    ]))], 8, _hoisted_60)
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("span", {
                                class: "col-resize-handle",
                                role: "separator",
                                "aria-orientation": "vertical",
                                tabindex: "0",
                                "aria-label": `Redimensionar coluna ${column.text}`,
                                "aria-valuenow": Math.round(_ctx.larguraAtualColuna(column)),
                                "aria-valuemin": _ctx.LARGURA_MINIMA_COLUNA,
                                "aria-valuemax": _ctx.LARGURA_MAXIMA_COLUNA,
                                "aria-valuetext": `${Math.round(_ctx.larguraAtualColuna(column))} pixels`,
                                onMousedown: ($event: any) => (_ctx.iniciarResizeColuna(column, $event)),
                                onKeydown: ($event: any) => (_ctx.redimensionarPorTeclado(column, $event))
                              }, null, 40, _hoisted_61)
                            ], 14, _hoisted_57))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("tbody", null, [
                    (_ctx.dataSource?.loading)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_62, [
                          _createElementVNode("td", {
                            colspan: _ctx.totalDeColunas,
                            style: {"height":"52.6px","padding-top":"10px"}
                          }, [...(_cache[36] || (_cache[36] = [
                            _createElementVNode("div", {
                              class: "spinner-border text-primary",
                              style: {"position":"absolute","left":"46%"},
                              "aria-hidden": "true"
                            }, null, -1),
                            _createElementVNode("span", { class: "apenas-leitor-tela" }, "Carregando registros...", -1)
                          ]))], 8, _hoisted_63)
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.dataSource?.loading && (_ctx.dataSource?.rows?.length ?? 0) == 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_64, [
                          _createElementVNode("td", { colspan: _ctx.totalDeColunas }, [...(_cache[37] || (_cache[37] = [
                            _createElementVNode("i", null, "Nenhum resultado", -1)
                          ]))], 8, _hoisted_65)
                        ]))
                      : _createCommentVNode("", true),
                    _renderSlot(_ctx.$slots, "body", {}, () => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSource?.rows, (row, indexRow) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: (row as any),
                          class: _normalizeClass(row._rowClass)
                        }, [
                          (_ctx.selectable)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_66, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onChangeSelection && _ctx.onChangeSelection(...args))),
                                  value: row,
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.rowsSelected) = $event)),
                                  class: "form-check-input",
                                  "aria-label": _ctx.rotuloSelecaoLinha(row, indexRow)
                                }, null, 40, _hoisted_67), [
                                  [_vModelCheckbox, _ctx.rowsSelected]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.rowDetails)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_68, [
                                _createElementVNode("button", {
                                  title: "Detalhes da linha",
                                  onClick: 
                        () => {
                          row.details = !row.details;
                          console.log(row.details);
                        }
                      ,
                                  type: "button",
                                  style: {"background-color":"transparent","border-color":"transparent"},
                                  class: "btn btn-link p-0 border-0 align-baseline",
                                  "aria-label": "Detalhes da linha"
                                }, [
                                  _createElementVNode("i", {
                                    style: {"font-size":"17px","color":"#a1a09f"},
                                    class: _normalizeClass(["uil", {
                          'uil-angle-down': row.details == true,
                          'uil-angle-right': !row.details,
                        }]),
                                    "aria-hidden": "true"
                                  }, null, 2)
                                ], 8, _hoisted_69)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.actions)
                            ? (_openBlock(), _createElementBlock("td", {
                                key: 2,
                                class: _normalizeClass({ 'fixed-side': _ctx.useFreezedColumn() })
                              }, [
                                _renderSlot(_ctx.$slots, "actions", {
                                  row: row,
                                  index: indexRow
                                })
                              ], 2))
                            : _createCommentVNode("", true),
                          (_ctx.buttonClickSave)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_70, [
                                _createElementVNode("button", {
                                  title: "Salvar dados da linha",
                                  onClick: ($event: any) => (_ctx.onChangeDataRow(row, $event, indexRow)),
                                  class: "btn btn-sm btn-success",
                                  style: {"margin-right":"5px"},
                                  "aria-label": "Salvar dados da linha"
                                }, [...(_cache[38] || (_cache[38] = [
                                  _createElementVNode("i", {
                                    class: "mdi mdi-floppy",
                                    "aria-hidden": "true"
                                  }, null, -1)
                                ]))], 8, _hoisted_71),
                                _createElementVNode("span", {
                                  class: "text-danger font-16",
                                  id: _ctx.gerarIdComponente(
                        `spanEmptyTextArea${_ctx.$props.idDivPaiConsulteGrid}`,
                        indexRow,
                        0
                      )
                        ,
                                  style: {"display":"none"}
                                }, [...(_cache[39] || (_cache[39] = [
                                  _createElementVNode("hr", null, null, -1),
                                  _createTextVNode(" * Clique no botão para salvar! ", -1)
                                ]))], 8, _hoisted_72)
                              ]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((!row.details ? _ctx.columnsData : new Array<ConsulteGridColumnsModel>), (column, index) => {
                            return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.ehCabecalhoDeLinha(column, row) ? 'th' : 'td'), {
                              scope: _ctx.ehCabecalhoDeLinha(column, row) ? 'row' : undefined,
                              key: index,
                              colspan: row.details ? _ctx.columnsData?.length : 1,
                              hidden: column.hidden,
                              class: _normalizeClass({ 'fixed-side': column.freezedcolumn }),
                              style: _normalizeStyle([_ctx.getColumnStyle(column), _ctx.ehCabecalhoDeLinha(column, row) ? { fontWeight: 'normal', textAlign: 'inherit' } : null])
                            }, {
                              default: _withCtx(() => [
                                (row.details)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                      _createElementVNode("table", _hoisted_74, [
                                        _createElementVNode("tbody", null, [
                                          _createElementVNode("tr", null, [
                                            _cache[41] || (_cache[41] = _createElementVNode("td", null, null, -1)),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnsData, (columnDetails, index) => {
                                              return (_openBlock(), _createElementBlock("td", { key: index }, [
                                                _renderSlot(_ctx.$slots, columnDetails.datafield, { row: row }, () => [
                                                  (columnDetails.cellsrenderer)
                                                    ? (_openBlock(), _createElementBlock("div", {
                                                        key: 0,
                                                        innerHTML: columnDetails.cellsrenderer(
                                    index,
                                    columnDetails.datafield,
                                    (row as any)[columnDetails.datafield]
                                  )
                                    
                                                      }, null, 8, _hoisted_75))
                                                    : _createCommentVNode("", true),
                                                  (!columnDetails.cellsrenderer && !columnDetails.columntype)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_76, _toDisplayString((row as any)[columnDetails.datafield]), 1))
                                                    : _createCommentVNode("", true),
                                                  (
                                    columnDetails.columntype &&
                                    columnDetails.columntype == 'checkbox'
                                  )
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                                                        _createElementVNode("label", _hoisted_78, [
                                                          _withDirectives(_createElementVNode("input", {
                                                            class: "form-check-input",
                                                            type: "checkbox",
                                                            "onUpdate:modelValue": ($event: any) => (((row as any)[columnDetails.datafield]) = $event),
                                                            disabled: ""
                                                          }, null, 8, _hoisted_79), [
                                                            [_vModelCheckbox, (row as any)[columnDetails.datafield]]
                                                          ]),
                                                          _cache[40] || (_cache[40] = _createElementVNode("span", { class: "form-check-sign" }, null, -1))
                                                        ])
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  (
                                    columnDetails.columntype && columnDetails.columntype == 'date'
                                  )
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_80, _toDisplayString(new Date(
                                        (row as any)[columnDetails.datafield]
                                      ).toLocaleDateString()), 1))
                                                    : _createCommentVNode("", true),
                                                  (
                                    columnDetails.columntype &&
                                    columnDetails.columntype == 'datetime'
                                  )
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_81, _toDisplayString((row as any)[columnDetails.datafield]
                                        ? _ctx.moment(
                                          new Date((row as any)[columnDetails.datafield])
                                        ).format('DD/MM/yyyy HH:mm')
                                        : ''), 1))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ]))
                                            }), 128))
                                          ])
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (row.details)
                                  ? _renderSlot(_ctx.$slots, "rowDetails", { row: row }, undefined, undefined, 1)
                                  : _createCommentVNode("", true),
                                (!row.details)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                      (!row.details)
                                        ? _renderSlot(_ctx.$slots, (column as ConsulteGridColumnsModel).datafield, { row: row }, () => [
                                            (column.cellsrenderer)
                                              ? (_openBlock(), _createElementBlock("div", {
                                                  key: 0,
                                                  innerHTML: column.cellsrenderer(
                            index,
                            column.datafield,
                            (row as any)[column.datafield]
                          )
                            
                                                }, null, 8, _hoisted_83))
                                              : _createCommentVNode("", true),
                                            (!column.cellsrenderer && !column.columntype && !(typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == true))
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_84, _toDisplayString((row as any)[column.datafield]), 1))
                                              : _createCommentVNode("", true),
                                            (!column.cellsrenderer && !column.columntype && (typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == true) && (typeof (row as any)[column.datafield]) == 'number')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                                                  _withDirectives(_createElementVNode("input", {
                                                    style: {"min-width":"80px"},
                                                    disabled: (typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == false),
                                                    onChange: ($event: any) => (
                                _ctx.buttonClickSave ? () => { } : _ctx.onChangeDataRow(row as any, $event)
                                ),
                                                    type: "number",
                                                    "onUpdate:modelValue": ($event: any) => (((row as any)[column.datafield]) = $event),
                                                    "aria-label": column.text,
                                                    class: "form-control"
                                                  }, null, 40, _hoisted_86), [
                                                    [_vModelText, (row as any)[column.datafield]]
                                                  ])
                                                ]))
                                              : _createCommentVNode("", true),
                                            (!column.cellsrenderer && column.editinputdefinition == undefined && !column.columntype && (typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == true) && (typeof (row as any)[column.datafield]) != 'number')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                                                  _withDirectives(_createElementVNode("input", {
                                                    disabled: (typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == false),
                                                    onChange: ($event: any) => (
                                _ctx.buttonClickSave ? () => { } : _ctx.onChangeDataRow(row as any, $event)
                                ),
                                                    type: "text",
                                                    "onUpdate:modelValue": ($event: any) => (((row as any)[column.datafield]) = $event),
                                                    "aria-label": column.text,
                                                    class: "form-control"
                                                  }, null, 40, _hoisted_88), [
                                                    [_vModelText, (row as any)[column.datafield]]
                                                  ])
                                                ]))
                                              : _createCommentVNode("", true),
                                            (!column.cellsrenderer &&
                              ((typeof column.editinputdefinition === 'object' && (column.editinputdefinition as any).type == 'textarea') || typeof column.editinputdefinition === 'string' && column.editinputdefinition == 'textarea')
                              && !column.columntype && (typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == true) && (typeof (row as any)[column.datafield]) != 'number')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                                                  _withDirectives(_createElementVNode("textarea", {
                                                    id: _ctx.gerarIdComponente(
                              `textarea${_ctx.$props.idDivPaiConsulteGrid}`,
                              indexRow,
                              index
                            )
                              ,
                                                    disabled: (typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == false),
                                                    onChange: ($event: any) => (
                                _ctx.buttonClickSave ? () => { } : _ctx.onChangeDataRow(row as any, $event)
                                ),
                                                    onInput: ($event: any) => (
                                  _ctx.handleInputTextAreaChange(
                                    `textarea${_ctx.$props.idDivPaiConsulteGrid}`,
                                    indexRow,
                                    index,
                                    _ctx.gerarIdComponente(
                                      `spanEmptyTextArea${_ctx.$props.idDivPaiConsulteGrid}`,
                                      indexRow,
                                      0
                                    )
                                  )
                                  ),
                                                    rows: (typeof column.editinputdefinition === 'object') ? ((column.editinputdefinition as any)?.rows ?? 1) : 1,
                                                    "onUpdate:modelValue": ($event: any) => (((row as any)[column.datafield]) = $event),
                                                    "aria-label": column.text,
                                                    class: "form-control"
                                                  }, null, 40, _hoisted_90), [
                                                    [_vModelText, (row as any)[column.datafield]]
                                                  ])
                                                ]))
                                              : _createCommentVNode("", true),
                                            (column.columntype && column.columntype == 'number' && (typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == true))
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                                                  _withDirectives(_createElementVNode("input", {
                                                    disabled: (typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == false),
                                                    onChange: ($event: any) => (
                                _ctx.buttonClickSave ? () => { } : _ctx.onChangeDataRow(row as any, $event)
                                ),
                                                    type: "number",
                                                    "onUpdate:modelValue": ($event: any) => (((row as any)[column.datafield]) = $event),
                                                    "aria-label": column.text,
                                                    class: "form-control",
                                                    style: {"min-width":"70px"}
                                                  }, null, 40, _hoisted_92), [
                                                    [_vModelText, (row as any)[column.datafield]]
                                                  ])
                                                ]))
                                              : _createCommentVNode("", true),
                                            (column.columntype && column.columntype == 'checkbox')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                                                  _createElementVNode("label", _hoisted_94, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      onChange: ($event: any) => (
                                _ctx.buttonClickSave ? () => { } : _ctx.onChangeDataRow(row as any, $event)
                                ),
                                                      class: "form-check-input",
                                                      type: "checkbox",
                                                      "onUpdate:modelValue": ($event: any) => (((row as any)[column.datafield]) = $event),
                                                      "aria-label": column.text,
                                                      disabled: !column.editable || (typeof column.editable === 'function' ? !column.editable((row as any)) : false)
                                                    }, null, 40, _hoisted_95), [
                                                      [_vModelCheckbox, (row as any)[column.datafield]]
                                                    ]),
                                                    _cache[42] || (_cache[42] = _createElementVNode("span", { class: "form-check-sign" }, null, -1))
                                                  ])
                                                ]))
                                              : _createCommentVNode("", true),
                                            (column.columntype && column.columntype == 'date' && !(typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == true)
                          )
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_96, _toDisplayString(new Date((row as any)[column.datafield]).toLocaleDateString()), 1))
                                              : _createCommentVNode("", true),
                                            (column.columntype && column.columntype == 'date' && (typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == true)
                          )
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                                                  _withDirectives(_createElementVNode("input", {
                                                    disabled: (typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == true),
                                                    onChange: ($event: any) => (
                                _ctx.buttonClickSave ? () => { } : _ctx.onChangeDataRow(row as any, $event)
                                ),
                                                    class: "form-control",
                                                    type: "date",
                                                    "onUpdate:modelValue": ($event: any) => (((row as any)[column.datafield]) = $event),
                                                    "aria-label": column.text
                                                  }, null, 40, _hoisted_98), [
                                                    [_vModelText, (row as any)[column.datafield]]
                                                  ])
                                                ]))
                                              : _createCommentVNode("", true),
                                            (column.columntype && column.columntype == 'datetime' && !(typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == true)
                          )
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_99, _toDisplayString((row as any)[column.datafield]
                                ? _ctx.moment(new Date((row as any)[column.datafield])).format(
                                  'DD/MM/yyyy HH:mm'
                                )
                                : ''), 1))
                                              : _createCommentVNode("", true),
                                            (column.columntype && column.columntype == 'datetime' && (typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == true)
                          )
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                                                  _withDirectives(_createElementVNode("input", {
                                                    disabled: (typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == false),
                                                    onChange: ($event: any) => (
                                _ctx.buttonClickSave ? () => { } : _ctx.onChangeDataRow(row as any, $event)
                                ),
                                                    class: "form-control",
                                                    type: "datetime-local",
                                                    "onUpdate:modelValue": ($event: any) => (((row as any)[column.datafield]) = $event),
                                                    "aria-label": column.text
                                                  }, null, 40, _hoisted_101), [
                                                    [_vModelText, (row as any)[column.datafield]]
                                                  ])
                                                ]))
                                              : _createCommentVNode("", true)
                                          ], undefined, 0)
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1032, ["scope", "colspan", "hidden", "class", "style"]))
                          }), 128))
                        ], 2))
                      }), 128))
                    ])
                  ])
                ], 2))
              : _createCommentVNode("", true)
          ], 34)
        ], 10, _hoisted_52),
        (!_ctx.singlePage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
              _createElementVNode("nav", _hoisted_103, [
                _createElementVNode("ul", _hoisted_104, [
                  _createElementVNode("li", _hoisted_105, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "page-link",
                      disabled: _ctx.dataSource!.pageNumber == 0,
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.goToPage(0))),
                      "aria-label": "Primeira página"
                    }, [...(_cache[43] || (_cache[43] = [
                      _createElementVNode("i", {
                        class: "mdi mdi-chevron-double-left",
                        "aria-hidden": "true"
                      }, null, -1)
                    ]))], 8, _hoisted_106)
                  ]),
                  _createElementVNode("li", _hoisted_107, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "page-link",
                      disabled: _ctx.dataSource!.pageNumber == 0,
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.prev())),
                      "aria-label": "Página anterior"
                    }, [...(_cache[44] || (_cache[44] = [
                      _createElementVNode("i", {
                        class: "mdi mdi-chevron-left",
                        "aria-hidden": "true"
                      }, null, -1)
                    ]))], 8, _hoisted_108)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayPages, (page) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: _normalizeClass(["paginate_button page-item", { active: _ctx.dataSource!.pageNumber + 1 == page }]),
                      key: (page as number)
                    }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "page-link",
                        onClick: ($event: any) => (_ctx.goToPage((page as number) - 1)),
                        "aria-current": _ctx.dataSource!.pageNumber + 1 == page ? 'page' : undefined,
                        "aria-label": `Página ${page}`
                      }, _toDisplayString(page), 9, _hoisted_109)
                    ], 2))
                  }), 128)),
                  _createElementVNode("li", _hoisted_110, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "page-link",
                      disabled: _ctx.dataSource!.pageNumber >= (_ctx.dataSource!.numberOfPages - 1),
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.next())),
                      "aria-label": "Próxima página"
                    }, [...(_cache[45] || (_cache[45] = [
                      _createElementVNode("i", {
                        class: "mdi mdi-chevron-right",
                        "aria-hidden": "true"
                      }, null, -1)
                    ]))], 8, _hoisted_111)
                  ]),
                  _createElementVNode("li", _hoisted_112, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "page-link",
                      disabled: _ctx.dataSource!.pageNumber >= (_ctx.dataSource!.numberOfPages - 1),
                      onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.goToPage(_ctx.dataSource!.numberOfPages - 1))),
                      "aria-label": "Última página"
                    }, [...(_cache[46] || (_cache[46] = [
                      _createElementVNode("i", {
                        class: "mdi mdi-chevron-double-right",
                        "aria-hidden": "true"
                      }, null, -1)
                    ]))], 8, _hoisted_113)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ], 544),
      _createElementVNode("p", _hoisted_114, _toDisplayString(_ctx.anuncioDoResultado), 1)
    ])
  ]))
}